<template>
  <el-dialog
    :visible.sync="innerVisible"
    title="信息认证说明"
    width="480px"
    :close-on-click-modal="true"
  >
    <p class="ca-auth-intro__content">
      请通过手机短信链接进行信息认证;如已认证完成，CA将进入办理流程，办理完成后，可通过系统查看，如有疑问请咨询客服。
    </p>
  </el-dialog>
</template>

<script>
export default {
  name: 'CaAuthIntroDialog',
  props: {
    visible: { type: Boolean, default: false },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
  },
}
</script>
